import dayjs from 'dayjs';
import { AppError, EipError } from 'src/redux/types';
const HOURS_PER_DAY = 24;
export const DEFAULT_WIN_RATE = 0.65;
export const MAX_PRICE = 99999;
export const formatErrorMessage = (error, arg) => {
  switch (error) {
    case EipError.USER_REJECTED_REQUEST:
      return 'Transaction has been canceled';

    case EipError.INVALID_ADDRESS:
      return 'The currently used wallet differs from the linked account wallet';

    case AppError.HERO_IN_THE_MATCH:
      return 'Hero is in a match';

    case AppError.INVALID_REMAIN_GTHC_BATTLE:
      return 'Not enough THC battles to be elligible for rental';

    case AppError.HERO_HAS_BEEN_RENTED:
      return 'Sorry, this item is no longer available';

    case AppError.LOW_RENT_BATTLES:
      return `Minimum battles for rent: ${arg === null || arg === void 0 ? void 0 : arg.minBattle}`;

    case AppError.HIGH_RENT_BATTLES:
      return `Maximum battles for rent: ${arg === null || arg === void 0 ? void 0 : arg.maxBattle}`;

    case AppError.INSUFFICIENT_BALANCE:
      return 'Insufficient balance';

    case AppError.LOW_RENT_PRICE:
      return `Minimum renting price: ${arg === null || arg === void 0 ? void 0 : arg.minPrice}`;

    case AppError.HIGH_RENT_PRICE:
      return `Maximum renting price: ${arg === null || arg === void 0 ? void 0 : arg.maxPrice}`;

    default:
      return `Error code: ${error}`;
  }
};
export const validateInputPrice = ({
  battle,
  maxRentBattles,
  price,
  rentalConfig
}) => {
  if (rentalConfig !== null && rentalConfig !== void 0 && rentalConfig.minTHCPrice && price < rentalConfig.minTHCPrice) {
    return AppError.LOW_RENT_PRICE;
  }

  if (rentalConfig !== null && rentalConfig !== void 0 && rentalConfig.minTHCBattles && battle < rentalConfig.minTHCBattles) {
    return AppError.LOW_RENT_BATTLES;
  }

  if (rentalConfig !== null && rentalConfig !== void 0 && rentalConfig.maxTHCPrice && price > rentalConfig.maxTHCPrice) {
    return AppError.HIGH_RENT_PRICE;
  }

  if (battle > maxRentBattles) {
    return AppError.HIGH_RENT_BATTLES;
  }

  return AppError.NO_ERROR;
};
export const getPriceAfterFee = (price, feeInPercent) => {
  return price > 0 ? price - price * feeInPercent / 100 : 0;
};
export const getRentPeriodMessage = ({
  rentBattle,
  rentalConfig,
  hero
}) => {
  const hours = Math.ceil(calculateRentPeriodSecond({
    rentBattle,
    rentalConfig,
    hero
  }) / 3600);
  if (hours === undefined) return '';
  return formatPeriodDay(hours);
};
export const formatPeriodDay = hours => {
  const duration = dayjs.duration(hours, 'hours');
  const totalDays = duration.asDays();
  const totalHours = duration.asHours();
  return `${Math.floor(totalDays)} days ${totalHours % HOURS_PER_DAY} hours`;
};
export const calculateRentPeriodSecond = ({
  rentBattle,
  rentalConfig,
  hero
}) => {
  if (!rentalConfig.rarityAdjust || rentBattle <= 0) {
    return 0;
  }

  return Math.ceil(rentBattle / hero.hero.dailyTHCBattleConfig * rentalConfig.rarityAdjust[hero.hero.rarity] * HOURS_PER_DAY) * 3600;
};
export const calculatePredictedReward = ({
  rentBattle,
  baseBonus,
  lostBonus,
  winBonus,
  winRate
}) => {
  return Math.ceil((baseBonus + winBonus) * rentBattle * winRate + lostBonus * rentBattle * (1 - winRate));
};